import { z } from "zod";

export const PayrollTotalsSchema = z.object({
    companyDebit: z.number(),
    netPayDebit: z.number(),
    taxDebit: z.number(),
    reimbursementDebit: z.number(),
    childSupportDebit: z.number(),
    reimbursements: z.number(),
    netPay: z.number(),
    grossPay: z.number(),
    employeeBonuses: z.number(),
    employeeCommissions: z.number(),
    employeeCashTips: z.number(),
    employeePaycheckTips: z.number(),
    additionalEarnings: z.number(),
    ownersDraw: z.number(),
    checkAmount: z.number(),
    employerTaxes: z.number(),
    employeeTaxes: z.number(),
    benefits: z.number(),
    employeeBenefitsDeductions: z.number(),
    deferredPayrollTaxes: z.number(),
});

export const ContractorPaymentTotalsSchema = z.object({
    debitAmount: z.number(),
    wageAmount: z.number(),
    reimbursementAmount: z.number(),
});

export const PayrollSchema = z.object({
    id: z.number(),
    payrollUuid: z.string(),
    companyUuid: z.string(),
    entityId: z.number(),
    offCycle: z.boolean(),
    processed: z.boolean(),
    processedDate: z.string().nullable(),
    calculatedAt: z.string().nullable(),
    payPeriodStartDate: z.string().nullable(),
    payPeriodEndDate: z.string().nullable(),
    payScheduleUuid: z.string().nullable().optional(),
    checkDate: z.string().nullable(),
    external: z.boolean(),
    totals: PayrollTotalsSchema.nullable().optional(),
    contractorPaymentTotals:
        ContractorPaymentTotalsSchema.nullable().optional(),
    createdAt: z.string().nullable(),
});

export type PayrollSchema = z.infer<typeof PayrollSchema>;
